import React, { useState } from "react";
import AddTpaModal from "./AddTpaModal";

const AddTpaButton = (props) => {
  const [displayAddTpaModal, setDisplayAddTpaModal] = useState(false);

  return (
    <div className="flex__container align-items-center justify-content-center">
      <div className="flex__container flex__container--end">
        <div className="button button--white" onClick={() => setDisplayAddTpaModal(true)}>
          Add TPA
        </div>
      </div>
      {displayAddTpaModal && (
        <AddTpaModal
          entity={props.entity}
          submit={props.submit}
          closeModal={() => setDisplayAddTpaModal(false)}
          submitPermission={props.submitPermission}
        />
      )}
    </div>
  );
};

export default AddTpaButton;
